import { render, staticRenderFns } from "./vtlabel.vue?vue&type=template&id=2a6cd98c&scoped=true"
import script from "./vtlabel.vue?vue&type=script&lang=js"
export * from "./vtlabel.vue?vue&type=script&lang=js"
import style0 from "./vtlabel.vue?vue&type=style&index=0&id=2a6cd98c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6cd98c",
  null
  
)

export default component.exports